<app-logo-header></app-logo-header>
<div class="main-container">
  <app-public-rounded-container>

    <!-- Shared Header -->
    <div class="tru-header text-center mb-4">
      <img src="../../../../../../../assets/images/logos/TruLogo.png" alt="TRU Logo" class="tru-logo mb-2" />
      <p class="tru-tagline">Another Day, Another Good Decision!</p>
    </div>

    <!-- Payment Details -->
    <div class="tru-payment-details mb-4">
      <h6 class="text-main-color">{{'BUYER_INFO.Tru.PaymentDetails' |translate}}</h6>
      <div class="d-flex justify-content-between">
        <span>{{'BUYER_INFO.Tru.TransactionAmount' |translate}}</span>
        <span class="fw-bold">EGP {{data.totalAmount}}</span>
      </div>
      <div class="d-flex justify-content-between">
        <span>{{'BUYER_INFO.Tru.MerchantName' |translate}}</span>
        <span class="fw-bold">{{data.businessName}}</span>
      </div>
      <div class="d-flex justify-content-between">
        <span>{{'BUYER_INFO.Tru.TransactionDate' |translate}}</span>
        <span class="fw-bold">{{ transactionDate }}</span>
      </div>
    </div>

    <div class="my-3" style="border-bottom:1px dashed #e9ecef;"></div>

    <!-- Step 1: Enter Tru ID -->
    <form [formGroup]="truForm" *ngIf="!isStep2">
      <div class="mb-3">
        <label class="form-label text-main-color">{{ 'BUYER_INFO.Tru.Please_enter_your_TRU_ID' | translate }}</label>
        <input type="text" class="form-control" formControlName="truId"
          placeholder="TRU ID" />
      </div>
      <div *ngIf="
          truForm.controls.truId.invalid &&
          (truForm.controls.truId.dirty || truForm.controls.truId.touched)
        " class="text-danger">
        <div *ngIf="truForm.controls.truId.errors?.['required']">
          {{ "BUYER_INFO.Tru.Required" | translate }}
        </div>
        <div *ngIf="truForm.controls.truId.errors?.['pattern']">
          {{ "BUYER_INFO.Tru.InvalidID" | translate }}
        </div>
      </div>

      <div class="help-text text-muted mb-3">
        <p class="text-main-color"><strong>{{ 'BUYER_INFO.Tru.Where_can_I_find_my_TRU_ID' | translate }}</strong></p>
        <ul>
          <li>{{ 'BUYER_INFO.Tru.Open_TRU_app' | translate }}</li>
          <li>{{ 'BUYER_INFO.Tru.Press_on_your_account' | translate }}</li>
          <li>{{ 'BUYER_INFO.Tru.Find_your_TRU_ID_below_your_name' | translate }}</li>
        </ul>
      </div>

      <button mat-button [disabled]="truForm.invalid" class="btn btn-confirm px-5 d-flex justify-content-center m-auto"
        (click)="createOrderRequest()">
        {{ "BUYER_INFO.Tru.Continue" | translate }}
      </button>

    </form>

    <!-- Step 2: Enter Transaction Token -->
    <form [formGroup]="truOtp" *ngIf="isStep2">

      <div class="help-text text-muted mb-3">
        <p class="text-main-color"><strong>{{ 'BUYER_INFO.Tru.Where_can_I_find_my_transaction_token' | translate
            }}</strong></p>
        <ul>
          <li>{{ 'BUYER_INFO.Tru.Keep_your_TRU_app_open' | translate }}</li>
          <li>{{ 'BUYER_INFO.Tru.Select_installment_plan' | translate }}</li>
          <li>{{ 'BUYER_INFO.Tru.Transaction_token_will_show' | translate }}</li>
        </ul>
      </div>

      <div class="mb-3">
        <label class="form-label text-main-color">{{ 'BUYER_INFO.Tru.Please_enter_transaction_token' | translate
          }}</label>
        <input type="text" class="form-control" formControlName="otp"
          placeholder="{{ 'BUYER_INFO.Tru.Enter_Token' | translate }}" />
      </div>
      <div *ngIf="
          truOtp.controls.otp.invalid &&
          (truOtp.controls.otp.dirty || truOtp.controls.otp.touched)
        " class="text-danger">
        <div *ngIf="truOtp.controls.otp.errors?.['required']">
          {{ "BUYER_INFO.Tru.Required" | translate }}
        </div>
        <div *ngIf="truOtp.controls.otp.errors?.['pattern']">
          {{ "BUYER_INFO.Tru.InvalidOTP" | translate }}
        </div>
      </div>

      <div class="text-muted small mb-3">
        {{ "BUYER_INFO.Tru.By_clicking" | translate }} <span style="color: #912d7f;">“{{ "BUYER_INFO.Tru.ConfirmPayment"
          | translate }}”</span>{{ "BUYER_INFO.Tru.policy_Text" | translate }} <strong>{{ merchantName }}</strong></div>

      <button mat-button [disabled]="truOtp.invalid" class="btn btn-confirm px-5 d-flex justify-content-center m-auto"
        (click)="confirmPayment()">
        {{ "BUYER_INFO.Tru.ConfirmPayment" | translate }}
      </button>
    </form>
    <p class="text-center text-muted my-2">
      {{ "BUYER_INFO.Tru.Powered_by_Easykash" | translate }}
    </p>
  </app-public-rounded-container>
</div>